<div class="snapshot-body">
  <div class="snapshot-caption">{{ 'snapshot_Caption' | xsI18n | titlecase }}</div>

  <div class="snapshot-header">
    <span class="snapshot-header-caption" sa-ellipsis-text>
      {{ 'snapshot_SavedBy_Caption' | xsI18n : snapshot?.createdBy }}
    </span>
    <span class="snapshot-pipe subtext-gray">|</span>
    <span class="snapshot-header-time">
      <xs-updating-time hidespan [time]="snapshot?.creationDate"></xs-updating-time>
    </span>
    <div class="delete-attachment-button condensed association-no-right-padding top-padding-xxxs">
      <div class="icon-spacing action" [sotiPopupTriggerFor]="popupDelete">
        <div 
          class="xs-remove-btn"
          [soti-tooltip]="'xs_delete_label' | xsI18n"
          placement="bottom"></div>
      </div>
    </div>
    <soti-popup #popupDelete="sotiPopup" position="endBottom" [offsetY]="-10" [offsetX]="3">
      <div *sotiPopupContent>
        <div class="popup-title">{{ 'popover_Confirm_Title' | xsI18n }}</div>
        <div class="popup-body-text">
          <p>{{ 'attachment_DeleteConfirmation' | xsI18n }}</p>
        </div>
        <ins-modal-footer2 class="popup-footer">
          <button (click)="cancelDelete()" class="xs-btn btn-outline btn-space">
            {{ 'xs_cancel_label_short' | xsI18n }}
          </button>
          <button (click)="deleteSnapshot()" class="xs-btn btn-primary">
            {{ 'xs_delete_label' | xsI18n }}
          </button>
        </ins-modal-footer2>
        <div class="popup-menu-beak"></div>
      </div>
    </soti-popup>
  </div>

  <xs-snapshot-activity-content
    [snapshot]="snapshot"
    [activityCtrl]="activityCtrl"
    (updateEditing)="updateEditing($event)"
    (saveNote)="saveNote($event)"
    [error]="error"
    [disable]="disableNote"
    [isSPPMode]="isSPPMode"
  ></xs-snapshot-activity-content>
</div>
